<template>
  <FloatingBall :bottom="bottom">
    <div class="complaint" @click="handleClick">
      <img class="img" :src="imgList[0]" alt="">
      <div v-if="msgNumText" class="msg-num">{{msgNumText}}</div>
    </div>
  </FloatingBall>
</template>

<script>
  import FloatingBall from './FloatingBall';
  export default {
    name: 'ComplaintEntry',
    props: {
        bottom: {
        type: Number,
        default: 120,
      },
    },
    data() {
      return {
        imgList: ['complaint.png'],
        msgNum: 0,
      };
    },
    components: {
      FloatingBall
    },
    computed: {
      msgNumText() {
        return this.msgNum > 99 ? '99' : this.msgNum;
      }
    },
    methods: {
      getMessageNum() {
        this.$request.complaint.getNoReadComplainsCount().then(res=>{
          this.msgNum = res.data;
        }).catch(err => console.log(err));
      },
      handleClick() {
        this.$router.push({ name: 'ComplaintRecord' });
      },
    },
    created() {
      this.$fission.setImgAddress('user/', this.imgList, false);
    },
    activated() {
      this.getMessageNum();
    },
  };
</script>

<style lang="less" scoped>
  .complaint {
    .img {
      width:60px;
    }
    .msg-num {
      position: absolute;
      top: 2px;
      right: 5px;
      width: 15px;
      height: 15px;
      line-height: 15px;
      text-align: center;
      font-size: 12px;
      color: #fff;
      background: red;
      border-radius: 50%;
    }
  }
</style>
